import { Box, Button, Dialog, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiPaper-root': {
    borderRadius: '16px',
    backgroundColor: '#FAFCFF',
  },
}));

export interface DialogButtonProps {
  previous?: boolean;
  pept?: boolean;
}

export const DialogButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'previous' && prop !== 'pept',
})<DialogButtonProps>(({ theme, previous, pept }) => ({
  width: '250px',
  backgroundColor: theme.palette.secondary.main,
  '&:hover': {
    filter: 'brightness(85%)',
  },
  '&:disabled': {
    opacity: '80%',
  },
  ...(previous && {
    backgroundColor: '#FFA75D',
    fontWeight: '600',
    '&:hover': {
      backgroundColor: '#FFA75D',
      filter: 'brightness(90%)',
    },
  }),
  [theme.breakpoints.down('lg')]: {
    ...(!pept && {
      minWidth: '180px',
      maxWidth: '200px',
    }),
  },
  [theme.breakpoints.down('xl')]: {
    ...(!pept && {
      width: 200,
      padding: 16,
    }),
  },
}));

export const DialogContainer = styled(Box)(() => ({
  minWidth: '600px',
  minHeight: '200px',
  padding: '40px 40px',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
}));

export const TextTypography = styled(Typography)(() => ({
  textAlign: 'center',
  fontSize: '22px',
  fontWeight: '600',
  color: '#595959',
}));

export const ButtonBox = styled(Box)(() => ({
  margin: '20px 0',
  display: 'flex',
  gap: '40px',
  justifyContent: 'center',
}));

export const OutlinedButton = styled(Button)(({ theme }) => ({
  maxWidth: '150px',
  border: `1.5px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: 'transparent',
  textTransform: 'lowercase',
}));

export const FilledButton = styled(Button)(({ theme }) => ({
  maxWidth: '150px',
  backgroundColor: theme.palette.secondary.main,
  textTransform: 'lowercase',
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));

export const ErrorMessage = styled(Typography)(() => ({
  textAlign: 'center',
  fontSize: '16px',
  color: '#FF334B',
}));
